import "core-js/modules/es.array.push.js";
export default {
  name: "GraphMatchMatrix",
  props: {
    matrix: {
      type: Array,
      default: () => []
    },
    size: {
      type: Number,
      default: 3
    },
    fillColor: {
      type: String,
      default: "#0077b6"
    }
  },
  computed: {
    normalized() {
      const rows = Array.isArray(this.matrix) ? this.matrix : [];
      const size = Number(this.size || 3);
      const result = [];
      for (let y = 0; y < size; y++) {
        const row = Array.isArray(rows[y]) ? rows[y] : [];
        const normalizedRow = [];
        for (let x = 0; x < size; x++) {
          normalizedRow.push(Number(row[x] || 0));
        }
        result.push(normalizedRow);
      }
      return result;
    }
  }
};